export var ProjectRole;
(function (ProjectRole) {
    ProjectRole["ADMIN"] = "ADMIN";
    ProjectRole["MANAGER"] = "MANAGER";
    ProjectRole["FOREMAN"] = "FOREMAN";
    ProjectRole["TRADE_CONTRACTOR"] = "TRADE_CONTRACTOR";
})(ProjectRole = ProjectRole || (ProjectRole = {}));
;
